import React__default, { useCallback } from 'react';
import { Editor, Transforms } from 'slate';
import { useFocused, ReactEditor } from 'slate-react';
import { isMarkActive } from '../../../../core/queries/isMarkActive.mjs';
import { toggleMark } from '../../../../core/transforms/toggleMark.mjs';
import { Button } from '../Button/Button.mjs';

function MarkButton({
  editor,
  plugin,
  onAction,
  ...props
}) {
  const {
    type
  } = plugin;
  const focused = useFocused();
  const active = focused && isMarkActive(editor, type);
  const handleAction = useCallback(event => {
    ensureSelection(editor);
    toggleMark(editor, type);
    onAction === null || onAction === void 0 ? void 0 : onAction(event);
  }, [editor, onAction, type]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({}, props, {
    active: active,
    onAction: handleAction,
    type: type
  }));
}
function ensureSelection(editor) {
  if (!editor.selection) {
    const start = Editor.start(editor, []);
    Transforms.select(editor, {
      anchor: start,
      focus: start
    });
    ReactEditor.focus(editor);
  }
}

export { MarkButton };
